import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDH6Gtm8SBjCYxZ741V6_bfk0lBMbxUYyo",
    authDomain: "task-tracker-db-d6ae8.firebaseapp.com",
    databaseURL: "https://task-tracker-db-d6ae8-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "task-tracker-db-d6ae8",
    storageBucket: "task-tracker-db-d6ae8.firebasestorage.app",
    messagingSenderId: "796758956810",
    appId: "1:796758956810:web:5e7a53f11a58bdd70df8f3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and Export Services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getDatabase(app);